module.exports = __webpack_public_path__ + "static/media/design.a5ff5f42.png";